/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DashboardComponent from "../components/dashboard/DashboardComponent";
import { RootState } from "../core/store/rootReducer";
import { IZReportListState, fetchZReportListByDateInterval } from "../features/ZReports/slices/zReportListSlices";
import useDateUtilities from "../hooks/useDateUtilities";
import "../i18n";
import DefaultLayout from "../layouts/PageLayout/DefaultLayout";
import { TemporalSelectorModes } from "../layouts/TemporalSelector/TemporalSelector";
import { ISiteState } from "../shared/slices/siteSlice";

const DashboardContainer: React.FC<{}> = () => {
	const [startDate, setStartDate] = useState<Date>();
	const [stopDate, setStopDate] = useState<Date>();
	const [datesRange, setDatesRange] = useState<Date[]>([]);
	const [currentMode, setCurrentMode] = useState<TemporalSelectorModes | undefined>();

	const [keyUpTimer, setKeyUpTimer] = useState<NodeJS.Timeout>();

	const site: ISiteState = useSelector((state: RootState) => state.SiteReducers);

	const zReportList: IZReportListState = useSelector((state: RootState) => state.ZReportListReducers);

	const dispatch = useDispatch();

	const { formatDateToServerFormat, getDatesInRange, shiftWeekFromDate } = useDateUtilities();

	const handleDateRangeChange = useCallback((startDate: Date, endDate: Date, mode?: TemporalSelectorModes) => {
		setCurrentMode(mode);
		setStopDate(endDate);
		setStartDate(startDate);
	}, []);

	useEffect(() => {
		fetchData();
	}, [stopDate, stopDate, currentMode]);

	const fetchData = () => {
		if (startDate && stopDate) {
			const dates = getDatesInRange(startDate, stopDate);
			setDatesRange(dates);

			const weeksToShift = Math.round(-(dates.length / 7));

			const compareStartDate = shiftWeekFromDate(startDate, weeksToShift);
			const compareStopDate = shiftWeekFromDate(stopDate, weeksToShift);

			keyUpTimer && clearTimeout(keyUpTimer);

			// setKeyUpTimer(
			// 	setTimeout(() => {
			dispatch(
				fetchZReportListByDateInterval(
					site.site?.id!!,
					formatDateToServerFormat(startDate),
					formatDateToServerFormat(stopDate),
					"day",
					formatDateToServerFormat(compareStartDate),
					formatDateToServerFormat(compareStopDate),
					currentMode
				)
			);
			// 	}, 300)
			// );
		}
	};

	return (
		<DefaultLayout>
			<DashboardComponent
				isError={zReportList.isError}
				onRefresh={fetchData}
				onDateChange={handleDateRangeChange}
				dates={datesRange}
				zReportList={zReportList}
				lastZReportDate={new Date(site.site?.last_z_report?.start_date || "")}
			/>
		</DefaultLayout>
	);
};

export default DashboardContainer;
